import { BaseballStatId } from '@collector/sportsapi-client-legacy'

import { ImportantStats } from '../../configuration'

export const importantStatsId: ImportantStats = [
  BaseballStatId.AB,
  BaseballStatId.RBI,
  BaseballStatId.Strikeouts,
  BaseballStatId.Errors,
  BaseballStatId.Hits,
]
